export default __webpack_public_path__ + "static/media/IMG_7580.35074770.jpeg";